<!--<div>-->
<!--  <pre>{{ model.value | json }}</pre>-->
<!--  <pre>{{ subConfig.valueChanges | async | json }}</pre>-->
<!--</div>-->
<!--<pre>{{ images.value | json }}</pre>-->
<!--<pre>{{ mappedValues$ | async | json }}</pre>-->
<div class="image">
  <ng-container *ngTemplateOutlet="basketIcon"></ng-container>

  <ng-container *ngTemplateOutlet="imageContainer"></ng-container>
</div>
<ng-template #preconfigImage>
  @if (showImage$ | async) {
    <div class="image">
      <ng-container *ngTemplateOutlet="basketIcon"></ng-container>
      <ng-container *ngTemplateOutlet="imageContainer"></ng-container>
    </div>
  }
</ng-template>
<ng-template #imageContainer>
  <ng-container *libIsHandset="desktopView">
    @if (anyImage$ | async; as imageToShow) {
      <pinch-zoom
        [auto-zoom-out]="true"
        [disableZoomControl]="'disable'"
        [double-tap-scale]="4.5"
        [limit-zoom]="4.5"
        backgroundColor="transparent"
        overflow="visible"
        >
        <img
          [src]="imageToShow | publicImageUrl: 1920:1920:'zalamo' | async"
          draggable="false"
          />
        </pinch-zoom>
      }
    </ng-container>

    <ng-template #desktopView>
      @if ((productType$ | async) === 'Triplex') {
        @if (currentScene.value === 0 || currentScene.value === 2) {
          <div
            class="triplex-image-picker"
            #triplexSlots
            >
            @for (area of currentUseMap$ | async; track area; let i = $index) {
              <div
          [ngStyle]="{
            'left.px': area.x1,
            'top.px': area.y1,
            'width.px': area.x2 - area.x1,
            'height.px': area.y2 - area.y1
          }"
                (click)="openTriplexPhotoPicker(i)"
              ></div>
            }
          </div>
        }
      }
      <div class="image-container">
        @if ($newImage | async; as newImageSrc) {
          <div animate.leave="album-image-leave">
            <img
              [src]="newImageSrc | publicImageUrl: 1920:1920:'zalamo' | async"
              class="bg"
              usemap="#workmap"
              />
              <img
                usemap="#workmap"
                (load)="newImageLoaded$.next(); imageLoaded($event)"
                [src]="newImageSrc | publicImageUrl: 1920:1920:'zalamo' | async"
                class="original"
                />
              </div>
            }
          </div>
          <div class="image-container second">
            @if (showOld$ | async) {
              <div animate.leave="album-image-leave">
                <img
                  [ngClass]="{ hidden: oldImageNotVisible$ | async }"
                  [src]="$oldImage | async | publicImageUrl: 1920:1920:'zalamo' | async"
                  class="old bg"
                  usemap="#workmap"
                  />
                  <img
                    (load)="oldImageLoaded$.next()"
                    usemap="#workmap"
                    [ngClass]="{ hidden: oldImageNotVisible$ | async }"
                    [src]="$oldImage | async | publicImageUrl: 1920:1920:'zalamo' | async"
                    class="old original"
                    />
                  </div>
                }
              </div>
            </ng-template>
            @if (preloaderVisible$ | async) {
              <div class="preloader">
                <div class="loader">
                  <span></span>
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <p>Komponujemy</p>
                @switch (productType$ | async) {
                  @case ('Album') {
                    <p>Twój album</p>
                  }
                  @case ('Triplex') {
                    <p>Twój tripleks</p>
                  }
                }
              </div>
            }
            @if (sceneImages.length > 1) {
              <div class="scenePicker">
                @for (scene of sceneImages; track scene; let i = $index) {
                  <div
                    (click)="currentScene.patchValue(i)"
                    [ngClass]="{ active: currentScene.value === i }"
                    class="scene"
                  ></div>
                }
              </div>
            }
          </ng-template>
          <ng-template #basketIcon>
            <button
              (click)="goToShoppingCart.emit()"
    [libValueOfTheBasket]="
      productsInPlayForPrice$
        | async
        | calcPriceForLookBook
          : (mappedValues$ | async)
          : priceRounding
          : priceUpdated
    "
              mat-fab
              >
              <mat-icon>shopping_cart</mat-icon>
            </button>
            <button (click)="closeMe.next()" mat-mini-fab class="closeMe">
              <mat-icon>close</mat-icon>
            </button>
            @if (isDev$ | async) {
              <lib-button
                (click)="showCalculationDetails()"
                icon-only
                >
                <mat-icon>info</mat-icon>
              </lib-button>
            }
          </ng-template>
          <ng-template #calcDetails>
            @for (product of productsInPlay$ | async; track product) {
              <div>
                {{ product.name }}
                {{
                product
                | priceWithConfigParser
                : (mappedValues$ | async)[product.productId]
                : []
                : "with file"
                | async
                | pricePicker
                }}
                @if (
                  (mappedValues$ | async) && (mappedValues$ | async)[product.productId]
                  ) {
                  <lib-config-drawer
                    [config]="product.config"
                    [preConfig]="(mappedValues$ | async)[product.productId]"
                    [resetOnNewConfig]="true"
                  ></lib-config-drawer>
                }
              </div>
            }
          </ng-template>
          <div class="controls">
            <div class="navigation">
              <div>
                @if (0 !== currentIndex) {
                  <lib-button
                    (click)="currentIndex = currentIndex - 1"
                    icon-only
                    >
                    <mat-icon>arrow_backward</mat-icon>
                  </lib-button>
                }
              </div>
              <div class="name">
                <span></span>{{ $safeNavigationMigration(item?.label) | langPicker | async }}<span></span>
              </div>
              <div>
                @if (
                  ((productType$ | async) === 'Triplex' && currentIndex < 3) ||
                  (currentIndex < 2 &&
                  (currentIndex !== 1 || decoration?.options?.length > 1))) {
                  <lib-button
                    (click)="currentIndex = currentIndex + 1"
                    [matTooltip]="$safeNavigationMigration(filtered[currentIndex + 1]?.label) | langPicker | async"
                    icon-only
                    >
                    <mat-icon>arrow_forward</mat-icon>
                  </lib-button>
                } @else {
                  <lib-button
                    (click)="goToShoppingCart.emit()"
                    icon-only
                    matTooltip="Przejdź do koszyka"
                    >
                    <mat-icon>shopping_cart</mat-icon>
                  </lib-button>
                }
              </div>
            </div>
            <div [formGroup]="model" class="menu">
              @switch (item?.type) {
                @case ('size') {
                  <lib-album-size
                    [formControl]="model.controls[item.customId]"
                    [type]="productType$ | async"
                    [options]="item.options"
                  ></lib-album-size>
                }
                @case ('list') {
                  <lib-list-picker
                    [formControl]="model.controls[item.customId]"
                    [limitOptions]="limitOptions"
                    [availableOptions]="availableOptions"
                    [options]="item.options"
                  ></lib-list-picker>
                }
                @case ('images') {
                  <lib-images-picker
                    [type]="productType$ | async"
                    (saved)="imagesChanged($event)"
                    [currentImages]="images.value"
                    [ratio]="ratio"
                    [contextId]="contextId"
                    [context]="context"
                    [availableImages]="availableImages"
                    [imageRelations]="imageRelations"
                  ></lib-images-picker>
                }
                @case ('decoration') {
                  <lib-album-decoration
                    [currentScene]="currentScene.value"
                    [currentValue]="model.value"
                    [decorationPreConfig]="personalizationPreConfig"
                    [formControl]="subConfig"
                    [height]="$safeNavigationMigration((size | async)?.height)"
                    [noDecorationOption]="noDecorationOption"
                    [noDecoration]="noDecoration$ | async"
                    [occasion]="occasion"
                    [options]="item.options"
                    [width]="$safeNavigationMigration((size | async)?.width)"
                  ></lib-album-decoration>
                }
              }
            </div>
          </div>
